"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptureThumbnail = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const classnames_1 = require("../../util/classnames");
const hidden_image_icon_1 = require("../hidden.image.icon/hidden.image.icon");
const capture_thumbnail_style_1 = require("./capture.thumbnail.style");
(0, theme_1.addStyles)(capture_thumbnail_style_1.Style);
const DEFAULT_THUMBNAIL_SIZE = 180;
exports.CaptureThumbnail = {
    view(collection, capture, ctx = {}) {
        const draw = services_1.Services.DrawState.getIkeDraw(collection, capture.objectId);
        const className = (0, classnames_1.classNames)(capture_thumbnail_style_1.CSS.container, ctx.className, {
            [capture_thumbnail_style_1.CSS.selectable]: typeof ctx.action === 'function',
            [capture_thumbnail_style_1.CSS.selected]: ctx.selected,
            [capture_thumbnail_style_1.CSS.hiddenCapture]: draw.state.imageVisibilityHidden,
        });
        const title = ctx.title;
        const onclick = ctx.action;
        const src = capture.thumbnail != null ? capture.thumbnail.url : capture.file.url;
        const size = {
            width: DEFAULT_THUMBNAIL_SIZE,
            height: DEFAULT_THUMBNAIL_SIZE,
        };
        if (ctx.size) {
            size.width = ctx.size;
            size.height = ctx.size;
        }
        const renderCtx = {
            draw,
            size,
            units: services_1.Services.UserSettings.units,
            isThumbnail: true,
            isInteractive: false,
            isEditable: false,
            scale: core_shared_1.SVGRenderer.scaleUI(draw.state, true),
        };
        return (0, mithril_1.m)('div', { className, title, onclick }, [
            ctx.truesize || draw.state.brightness !== 1
                ? (0, mithril_1.m)('div', { className: capture_thumbnail_style_1.CSS.overlay }, core_shared_1.SVGRenderer.view(renderCtx))
                : (0, mithril_1.m)('img', { className: capture_thumbnail_style_1.CSS.image, src }),
            ctx.crosshair && (0, mithril_1.m)('div', { className: capture_thumbnail_style_1.CSS.crosshair }),
            ctx.truesize && ctx.icon && (0, mithril_1.m)('div', { className: capture_thumbnail_style_1.CSS.photomeasure }),
            draw.state.imageVisibilityHidden && hidden_image_icon_1.HiddenImageIcon.view(),
            (0, mithril_1.m)('div', { className: capture_thumbnail_style_1.CSS.date }, services_1.Services.DateTime.formatDate(capture.collectedAt.iso)),
        ]);
    },
};
//# sourceMappingURL=capture.thumbnail.js.map